import React from 'react';
import TelephoneNumber from '../../subcomponents/TelephoneNumber';
import PublicWrapper from "../../theme/wrappers/PublicWrapper";


class SplashScreen extends React.Component {



    render() {
        return (
            <div>
                <section className="hero is-fullheight" id="top-hero">
                    <div className="hero-body" style={{zIndex: 2}}>
                        <div className="container" style={{maxWidth: '800px'}}>
                            <div className={'hero-logo is-centered'}/>
                            {/*<h1 className="title has-text-centered">*/}
                            {/*    Find your funder.*/}
                            {/*</h1>*/}
                            <h4 className="subtitle has-text-centered mt-3">
                                PACEfi is temporarily inactive as we prepare to bring out its next iteration.
                            </h4>
                            <h4 className="subtitle has-text-centered mt-3">
                                The PACE address eligibility feature will be available in December. A full beta will be available in early 2021.
                                To be on our notification list, pls <a href='mailto:cleanfinancing@gmail.com'>email us.</a> To qualify an address during this period, please <a href='mailto:cleanfinancing@gmail.com'>email us</a> or call us at <TelephoneNumber />
                            </h4>

                        </div>
                    </div>
                </section>
            </div>
        )
    }

}

export default SplashScreen;
